import React from 'react';

import { useLocale } from '~/src/components/LocaleProvider';

import { TeachersCarouselDataEN } from './TeachersCarouselDataEN';
import { TeachersCarouselDataES } from './TeachersCarouselDataES';
import { TeacherCard } from '../../cards/TeacherCard';
import { createSlickSettings } from '../../carousels/BaseCarousel/createSlickSettings';
import { TeacherCarousel } from '../../carousels/TeacherCarousel';
import { LazyRender } from '../../LazyRender';
import { carouselSettings, spaceBetweenCards } from '../carouselSettings';

const Data: React.FC<{
  children: (data: React.ComponentProps<typeof TeacherCarousel>['items']) => React.ReactNode;
}> = props => {
  const { locale } = useLocale();
  if (locale === 'es') {
    return <TeachersCarouselDataES {...props} />;
  }
  return <TeachersCarouselDataEN {...props} />;
};

const desktopSettings = {
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  // NOTE it's make sense to 'progressive' it only if you need to see cards beyond the borders
  lazyLoad: 'progressive' as const,
};

const slickSettings = createSlickSettings({
  sm: {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  },
  md: {
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
  },
  lg: { ...desktopSettings, slidesToShow: 1 },
  xl: desktopSettings,
  xxl: desktopSettings,
});

export const TeachersCarousel: React.FC<{ className?: string }> = props => {
  return (
    <div {...props}>
      <Data>
        {data => (
          <LazyRender placeholder={<TeacherCarousel.Placeholder />}>
            <TeacherCarousel
              items={data}
              {...carouselSettings}
              style={{
                width: `${TeacherCard.dimension.width + spaceBetweenCards}px`,
                height: 'auto',
              }}
              maxItems={18}
              slickSettings={slickSettings}
            />
          </LazyRender>
        )}
      </Data>
    </div>
  );
};
